import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const API = process.env.REACT_APP_MASTER_API_BASE_URL;

/* =========================================================
   CREATE TASKS
========================================================= */
export const createTaskMilestone = createAsyncThunk(
  "taskMilestone/createTaskMilestone",
  async (tasks, { rejectWithValue, getState }) => {
    try {
      const token = getState()?.auth?.activeUser?.data?.accessToken;

      if (!token) return rejectWithValue("Login required.");

      const response = await axios.post(
        `${API}/api/MilestoneMaster/createTaskMilestone`,
        tasks,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(
        error?.response?.data?.message ||
        error?.message ||
        "Task creation failed"
      );
    }
  }
);

/* =========================================================
   UPDATE TASKS  ✅ (OPTIONAL BUT RECOMMENDED)
========================================================= */
export const updateTaskMilestone = createAsyncThunk(
  "taskMilestone/updateTaskMilestone",
  async (tasks, { rejectWithValue, getState }) => {
    try {
      const token = getState()?.auth?.activeUser?.data?.accessToken;

      if (!token) return rejectWithValue("Login required.");

      const response = await axios.put(
        `${API}/api/MilestoneMaster/updateTaskMilestone`,
        tasks,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(
        error?.response?.data?.message ||
        error?.message ||
        "Task update failed"
      );
    }
  }
);

/* =========================================================
   CREATE SUBTASKS
========================================================= */
export const createSubTaskMilestone = createAsyncThunk(
  "taskMilestone/createSubTaskMilestone",
  async (subtasks, { rejectWithValue, getState }) => {
    try {
      const token = getState()?.auth?.activeUser?.data?.accessToken;

      if (!token) return rejectWithValue("Login required.");

      const response = await axios.post(
        `${API}/api/MilestoneMaster/createSubTaskMilestone`,
        subtasks,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(
        error?.response?.data?.message ||
        error?.message ||
        "SubTask creation failed"
      );
    }
  }
);

/* =========================================================
   UPDATE SUBTASKS  ✅🔥 THIS WAS MISSING
========================================================= */
export const updateSubTaskMilestone = createAsyncThunk(
  "taskMilestone/updateSubTaskMilestone",
  async (subtasks, { rejectWithValue, getState }) => {
    try {
      const token = getState()?.auth?.activeUser?.data?.accessToken;

      if (!token) return rejectWithValue("Login required.");

      const response = await axios.put(
        `${API}/api/MilestoneMaster/updateSubTaskMilestone`,
        subtasks,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(
        error?.response?.data?.message ||
        error?.message ||
        "SubTask update failed"
      );
    }
  }
);

/* =========================================================
   GET SUBTASKS
========================================================= */
export const getSubTasks = createAsyncThunk(
  "task/getSubTasks",
  async (taskId, { getState, rejectWithValue }) => {
    try {
      const token = getState()?.auth?.activeUser?.data?.accessToken;

      if (!token) return rejectWithValue("Login required.");

      const res = await axios.get(
        `${API}/api/MilestoneMaster/subtasks/${taskId}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      return res.data;
    } catch (err) {
      return rejectWithValue(
        err?.response?.data?.message ||
        err?.message ||
        "Failed to load subtasks"
      );
    }
  }
);

/* =========================================================
   GET PROJECT TASKS
========================================================= */
export const getProjectTasks = createAsyncThunk(
  "taskMilestone/getProjectTasks",
  async (projectId, { rejectWithValue, getState }) => {
    try {
      const token = getState()?.auth?.activeUser?.data?.accessToken;

      if (!token) return rejectWithValue("Login required.");

      const res = await axios.get(
        `${API}/api/MilestoneMaster/project/${projectId}/tasks`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      return res.data;
    } catch (err) {
      return rejectWithValue(
        err?.response?.data?.message ||
        err?.message ||
        "Failed to load tasks"
      );
    }
  }
);

/* =========================================================
   GET MILESTONE SUMMARY
========================================================= */
export const getMilestoneSummary = createAsyncThunk(
  "taskMilestone/getMilestoneSummary",
  async (projectId, { rejectWithValue, getState }) => {
    try {
      const token = getState()?.auth?.activeUser?.data?.accessToken;

      if (!token) return rejectWithValue("Login required.");

      const response = await axios.get(
        `${API}/api/MilestoneMaster/project/${projectId}/milestone-summary`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(
        error?.response?.data ||
        "Failed to fetch milestone summary"
      );
    }
  }
);